import { useContext } from "react"
import { dispatcher_context } from "../../hooks/useStats_dispatcher"
import { RSODynamicDispDynamicDaily } from './components/RSODynamicDispDynamicDaily/RSODynamicDispDynamicDaily'
import { RSODynamicDispDynamicOper } from './components/RSODynamicDispDynamicOper/RSODynamicDispDynamicOper'
import { DynamicDispatchProvider } from "../../hooks/useStats_dispatcher_dynamic"

export let RSODynamicDispDynamic = () => {

  let { dynamicActiveTab } = useContext(dispatcher_context)

  return (
    <>
      <DynamicDispatchProvider>
        {dynamicActiveTab === "Дневной отчет" &&
          <RSODynamicDispDynamicDaily />
        }

        {dynamicActiveTab === "Оперативные данные" &&
          <RSODynamicDispDynamicOper />
        }
      </DynamicDispatchProvider>
    </>
  )
}
